export default "__VITE_ASSET__7985875d__"